// extracted by mini-css-extract-plugin
export default {"champDeTexte":"ChampDeTexte_champDeTexte__MUXU+"};